// Ref: https://daisyui.com/components/loading/#loading-spinner
export default function SpinnerCircle() {
  return (
    <span className="loading loading-spinner loading-lg text-primary"></span>
  );
}
